import { useQuery } from "@tanstack/react-query";

import { api } from "@/config/api";
import { queryKeys } from "@/hooks/queries";
import type { ApiResponse } from "@/types";

interface WeeklyLeagueStanding {
  weekId: string;
  userId: string;
  displayName: string;
  weeklyXp: number;
  league: string;
  rank: number;
}

interface UserStanding {
  weekId: string;
  userId: string;
  displayName: string;
  weeklyXp: number;
  league: string;
  rank: number;
  totalInLeague: number;
}

export interface WeeklyLeagueData {
  weekId: string;
  standings: WeeklyLeagueStanding[];
  userStanding: UserStanding | null;
}

interface WeeklyLeagueApiResponse extends ApiResponse {
  weeklyLeague: WeeklyLeagueData;
}

export function useWeeklyLeague() {
  return useQuery({
    queryKey: queryKeys.weeklyLeague,
    queryFn: () => api.get<WeeklyLeagueApiResponse>("/api/weekly-league"),
    select: (data) => data.weeklyLeague,
  });
}
